@if (packageType$ | async; as packageType) {
  <div class="layout-row gap-xl p-pane" elderPlugParentForm>
    <div class="flex layout-col">
      <div class="layout-row">
        <div class="flex layout-col">
          <!-- Identifications -->
          <elder-pane-subtitle>{{ 'context.identification' | translate }} </elder-pane-subtitle>
          <div class="layout-row gap-sm">
            @if (creationMode$ | async) {
              <mat-form-field class="flex">
                <mat-label>{{ 'context.id' | translate }}</mat-label>
                <input
                  matInput
                  name="id"
                  required
                  placeholder="{{ 'context.id' | translate }}"
                  pattern="{{ idValidatorPattern }}"
                  [(ngModel)]="packageType.id"
                />
                <mat-error elderValidationError></mat-error>
              </mat-form-field>
            }
            <mat-form-field class="flex">
              <mat-label>{{ 'context.name' | translate }}</mat-label>
              <input
                matInput
                name="name"
                required
                placeholder="{{ 'context.name' | translate }}"
                [(ngModel)]="packageType.name"
              />
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </div>
          <div class="layout-row gap-sm">
            <mat-form-field class="flex">
              <mat-label>{{ 'context.description' | translate }}</mat-label>
              <input
                matInput
                name="description"
                placeholder="{{ 'context.description' | translate }}"
                [(ngModel)]="packageType.description"
              />
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="flex layout-col">
      <div class="layout-row">
        <div class="flex layout-col">
          <!-- Other -->
          <elder-pane-subtitle>{{ 'context.other' | translate }}</elder-pane-subtitle>
          <div class="layout-row gap-sm">
            <mat-form-field class="flex">
              <mat-label>{{ 'Gewichtseinheit' | translate }}</mat-label>
              <elder-select
                elderUnitSelect
                name="weightUnit"
                required
                placeholder="{{ 'Gewichtseinheit' | translate }}"
                [unitDimension]="defaultWeightDimension"
                [(ngModel)]="weighUnitInfo"
                (ngModelChange)="changeWeightUnit($event)"
              />
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
            <mat-form-field class="flex">
              <mat-label>{{ 'Dimensionseinheit' | translate }}</mat-label>
              <elder-select
                elderUnitSelect
                name="dimensionUnit"
                required
                placeholder="{{ 'Dimensionseinheit' | translate }}"
                [unitDimension]="defaultLengthDimension"
                [(ngModel)]="dimensionUnitInfo"
                (ngModelChange)="changeDimensionUnit($event)"
              />
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'Standard Max Gebinde Gewicht' | translate }}</mat-label>
              <elder-quantity-input
                name="defaultMaxWeight"
                placeholder="{{ 'Standard Max Gebinde Gewicht' | translate }}"
                [(ngModel)]="packageType.defaultMaxWeight"
              >
              </elder-quantity-input>
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </div>
          <div class="layout-row gap-sm">
            <mat-form-field class="flex">
              <mat-label>{{ 'context.materialGroup' | translate }}</mat-label>
              <input
                matInput
                name="materialGroupId"
                placeholder="{{ 'context.materialGroup' | translate }}"
                [(ngModel)]="packageType.materialGroupId"
              />
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
}
